import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const membershipAuthSessionResponseSchema = jsonObject
export const membershipAuthLogoutResponseSchema = jsonObject
export type MembershipAuthSessionResponse = z.infer<typeof membershipAuthSessionResponseSchema>
export type MembershipAuthLogoutResponse = z.infer<typeof membershipAuthLogoutResponseSchema>
